import { IUser } from '../../core/interfaces/user.interface';
import { PERMISSION_NAMES, REFUSAL_VERBS } from '../constant/permission.constant';
import { EntityMode } from '../enum/entity-mode.enum';
import { PermissionKey } from '../enum/permission-key.enum';
import { PermissionLevel } from '../enum/permission-level.enum';

// Whether the person holds a permission at least to the level asked for; `manage` includes `view`.
export const holdsPermission = (
    user: IUser | null,
    permission: PermissionKey,
    level: PermissionLevel,
): boolean => {
    const granted = user?.permissions[permission];
    return level === PermissionLevel.VIEW ? !!granted : granted === PermissionLevel.MANAGE;
};

// Why a page or button is off: what was tried, on what, as the person sees it.
export const refusalReasonFor = (permission: PermissionKey, mode: EntityMode): string =>
    `Your role does not allow ${REFUSAL_VERBS[mode]} ${PERMISSION_NAMES[permission]}.`;
